import React from 'react';
import { Spinner } from 'react-bootstrap';

function AppLoading() {
  return (
    <div className="app-loading">
      <Spinner
        animation="border"
        variant="primary"
        style={{
          width: '3rem',
          height: '3rem',
        }}
      />
    </div>
  );
}

export default AppLoading;
